import * as React from "react";

var NoFound = function NoFound() {
  return /*#__PURE__*/React.createElement("svg", {
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "\u7F16\u7EC4 8"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-22.3%",
    y: "-19%",
    width: "152%",
    height: "142.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-noFound"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.835294118 0 0 0 0 0.882352941 0 0 0 0 0.988235294 0 0 0 1 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.905 9.276l20.379 20.562v74.355a4.899 4.899 0 01-4.899 4.9H18.431a4.899 4.899 0 01-4.9-4.9V14.175a4.899 4.899 0 014.9-4.9h55.474z",
    id: "path-noFound"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .585h160v160H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.423 25.585)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#E9EEF7",
    transform: "rotate(-6 38.471 52.344)",
    x: 4.961,
    y: 4.248,
    width: 67.021,
    height: 96.191,
    rx: 5.443
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-noFound)",
    xlinkHref: "#path-noFound"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#path-noFound"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E9EEF7",
    x: 29.79,
    y: 35.463,
    width: 48.224,
    height: 4.763,
    rx: 2.381
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E9EEF7",
    x: 29.79,
    y: 48.69,
    width: 41.947,
    height: 4.763,
    rx: 2.381
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.441 29.838L74.062 9.276l-.12 15.626a4.899 4.899 0 004.9 4.936h15.6z",
    fill: "#E9EEF7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.093 87.842)",
    fill: "#CDD5E2"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-49 31.284 30.083)",
    x: 29.038,
    y: 23.109,
    width: 4.491,
    height: 13.948,
    rx: 1.497
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.718 0c8.68 0 15.717 7.037 15.717 15.718 0 8.68-7.037 15.717-15.717 15.717C7.037 31.435 0 24.398 0 15.718 0 7.037 7.037 0 15.718 0zm0 3.293c-6.862 0-12.425 5.563-12.425 12.425 0 6.861 5.563 12.424 12.425 12.424 6.861 0 12.424-5.563 12.424-12.424 0-6.862-5.563-12.425-12.424-12.425z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 25.755)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#B6C2D4",
    cx: 13.608,
    cy: 13.608,
    r: 13.608
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.923 10.733c.147-2.714 1.47-4.07 3.965-4.07 0 0 0 0 0 0a3.445 3.445 0 012.806 5.444c-.232.326-.513.671-.842 1.037-1.192 1.322-2.389 1.657-2.389 3.723",
    stroke: "#FFF",
    strokeWidth: 2.381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 13.438,
    cy: 20.753,
    r: 1.531
  }))));
};

export default NoFound;